import { Icon } from '../Icon/Icon';
import { Typography } from '../Typography/Typography';
import { getKDSClasses, merge } from '../util';
import { isDebug } from '../debug';
import { ValidIcons } from '../Icon/library';
import { SemanticColor } from '../Colors';
import { getTailwindSafeColorClassName } from '../Colors/utils';

export interface BadgeProps {
  icon?: ValidIcons;
  label?: string;
  color?: SemanticColor;
  bgColor?: SemanticColor;
  disabled?: boolean;
  disabledColor?: SemanticColor;
  disabledBgColor?: SemanticColor;
  truncate?: boolean;
  enableTooltip?: boolean;
}

export const Badge = (props: BadgeProps) => {
  const {
    icon,
    label,
    color = 'font-secondary',
    bgColor = 'background-light',
    disabled,
    disabledColor = 'font-placeholder',
    disabledBgColor = 'background-light',
    truncate = true,
    enableTooltip = true,
  } = props;

  const { debugClassName } = isDebug();

  const contentColor = disabled ? disabledColor : color;
  const backgroundColor = disabled ? disabledBgColor : bgColor;

  const classes = merge(
    getKDSClasses('badge'),
    'inline-flex items-center gap-[5px] rounded-[10px] py-[4px] px-[10px] max-w-[200px]',
    getTailwindSafeColorClassName(backgroundColor, 'background'),
    debugClassName
  );

  if (!icon && !label) {
    return null;
  }

  return (
    <div
      className={classes}
      data-kds-badge-label={label}
      data-kds-badge-icon={icon}
    >
      {icon && (
        <Icon icon={icon} size="sm" color={contentColor} className="shrink-0" />
      )}
      {label && (
        <Typography
          size="xs"
          weight="semibold"
          color={contentColor}
          className="min-w-0"
          truncate={truncate}
          enableTooltip={enableTooltip}
        >
          {label}
        </Typography>
      )}
    </div>
  );
};
